/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { ApPayeeContactInformEmailTemplateResponse } from '../model/apPayeeContactInformEmailTemplateResponse';
import type { ApPayeeContactInformPdfTemplateResponse } from '../model/apPayeeContactInformPdfTemplateResponse';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { PostApiJsApPayeesInvitationsMails200 } from '../model/postApiJsApPayeesInvitationsMails200';
import type { PostApiJsApPayeesInvitationsMailsBody } from '../model/postApiJsApPayeesInvitationsMailsBody';
import type { PostApiJsApPayeesInvitationsPdfs200 } from '../model/postApiJsApPayeesInvitationsPdfs200';
import type { PostApiJsApPayeesInvitationsPdfsBody } from '../model/postApiJsApPayeesInvitationsPdfsBody';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import type { UpdateReceivedInvoiceErrorResponse } from '../model/updateReceivedInvoiceErrorResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get Payee Contact Inform PDF Template for Office Member
 */
export const useGetApPayeeContactInformPdfTemplateHook = () => {
  const getApPayeeContactInformPdfTemplate =
    useCustomClient<ApPayeeContactInformPdfTemplateResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApPayeeContactInformPdfTemplate(
      {
        url: `/api/js/ap_payee_contact_inform_pdf_template`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApPayeeContactInformPdfTemplateQueryKey = () => {
  return [`/api/js/ap_payee_contact_inform_pdf_template`] as const;
};

export const useGetApPayeeContactInformPdfTemplateQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApPayeeContactInformPdfTemplateQueryKey();

  const getApPayeeContactInformPdfTemplate =
    useGetApPayeeContactInformPdfTemplateHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
    >
  > = ({ signal }) =>
    getApPayeeContactInformPdfTemplate(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApPayeeContactInformPdfTemplateQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
  >
>;
export type GetApPayeeContactInformPdfTemplateQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get Payee Contact Inform PDF Template for Office Member
 */
export const useGetApPayeeContactInformPdfTemplate = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApPayeeContactInformPdfTemplateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApPayeeContactInformPdfTemplateSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApPayeeContactInformPdfTemplateQueryKey();

  const getApPayeeContactInformPdfTemplate =
    useGetApPayeeContactInformPdfTemplateHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
    >
  > = ({ signal }) =>
    getApPayeeContactInformPdfTemplate(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApPayeeContactInformPdfTemplateSuspenseQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
  >
>;
export type GetApPayeeContactInformPdfTemplateSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get Payee Contact Inform PDF Template for Office Member
 */
export const useGetApPayeeContactInformPdfTemplateSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApPayeeContactInformPdfTemplateHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApPayeeContactInformPdfTemplateSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Export multiple PDF Files for Ap Payee Invitations
 */
export const usePostApiJsApPayeesInvitationsPdfsHook = () => {
  const postApiJsApPayeesInvitationsPdfs =
    useCustomClient<PostApiJsApPayeesInvitationsPdfs200>();

  return (
    postApiJsApPayeesInvitationsPdfsBody: BodyType<PostApiJsApPayeesInvitationsPdfsBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return postApiJsApPayeesInvitationsPdfs(
      {
        url: `/api/js/ap_payees/invitations/pdfs`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postApiJsApPayeesInvitationsPdfsBody,
      },
      options
    );
  };
};

export const usePostApiJsApPayeesInvitationsPdfsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UpdateReceivedInvoiceErrorResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsPdfsHook>>
    >,
    TError,
    { data: BodyType<PostApiJsApPayeesInvitationsPdfsBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsPdfsHook>>
  >,
  TError,
  { data: BodyType<PostApiJsApPayeesInvitationsPdfsBody> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const postApiJsApPayeesInvitationsPdfs =
    usePostApiJsApPayeesInvitationsPdfsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsPdfsHook>>
    >,
    { data: BodyType<PostApiJsApPayeesInvitationsPdfsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiJsApPayeesInvitationsPdfs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiJsApPayeesInvitationsPdfsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsPdfsHook>>
  >
>;
export type PostApiJsApPayeesInvitationsPdfsMutationBody =
  BodyType<PostApiJsApPayeesInvitationsPdfsBody>;
export type PostApiJsApPayeesInvitationsPdfsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UpdateReceivedInvoiceErrorResponse
>;

/**
 * @summary Export multiple PDF Files for Ap Payee Invitations
 */
export const usePostApiJsApPayeesInvitationsPdfs = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UpdateReceivedInvoiceErrorResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsPdfsHook>>
    >,
    TError,
    { data: BodyType<PostApiJsApPayeesInvitationsPdfsBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    usePostApiJsApPayeesInvitationsPdfsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Send multiple emails for Payee Invitations (Supplier Upload Invitation)
 */
export const usePostApiJsApPayeesInvitationsMailsHook = () => {
  const postApiJsApPayeesInvitationsMails =
    useCustomClient<PostApiJsApPayeesInvitationsMails200>();

  return (
    postApiJsApPayeesInvitationsMailsBody: BodyType<PostApiJsApPayeesInvitationsMailsBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return postApiJsApPayeesInvitationsMails(
      {
        url: `/api/js/ap_payees/invitations/mails`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postApiJsApPayeesInvitationsMailsBody,
      },
      options
    );
  };
};

export const usePostApiJsApPayeesInvitationsMailsMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsMailsHook>>
    >,
    TError,
    { data: BodyType<PostApiJsApPayeesInvitationsMailsBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsMailsHook>>
  >,
  TError,
  { data: BodyType<PostApiJsApPayeesInvitationsMailsBody> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const postApiJsApPayeesInvitationsMails =
    usePostApiJsApPayeesInvitationsMailsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsMailsHook>>
    >,
    { data: BodyType<PostApiJsApPayeesInvitationsMailsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiJsApPayeesInvitationsMails(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiJsApPayeesInvitationsMailsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsMailsHook>>
  >
>;
export type PostApiJsApPayeesInvitationsMailsMutationBody =
  BodyType<PostApiJsApPayeesInvitationsMailsBody>;
export type PostApiJsApPayeesInvitationsMailsMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse
>;

/**
 * @summary Send multiple emails for Payee Invitations (Supplier Upload Invitation)
 */
export const usePostApiJsApPayeesInvitationsMails = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsMailsHook>>
    >,
    TError,
    { data: BodyType<PostApiJsApPayeesInvitationsMailsBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    usePostApiJsApPayeesInvitationsMailsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get office member permission for sending invitation
 */
export const usePostApiJsApPayeesInvitationsPermissionHook = () => {
  const postApiJsApPayeesInvitationsPermission = useCustomClient<void>();

  return (options?: SecondParameter<ReturnType<typeof useCustomClient>>) => {
    return postApiJsApPayeesInvitationsPermission(
      { url: `/api/js/ap_payees/invitations/permission`, method: 'POST' },
      options
    );
  };
};

export const usePostApiJsApPayeesInvitationsPermissionMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePostApiJsApPayeesInvitationsPermissionHook>
      >
    >,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsPermissionHook>>
  >,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const postApiJsApPayeesInvitationsPermission =
    usePostApiJsApPayeesInvitationsPermissionHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePostApiJsApPayeesInvitationsPermissionHook>
      >
    >,
    void
  > = () => {
    return postApiJsApPayeesInvitationsPermission(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiJsApPayeesInvitationsPermissionMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePostApiJsApPayeesInvitationsPermissionHook>>
  >
>;

export type PostApiJsApPayeesInvitationsPermissionMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get office member permission for sending invitation
 */
export const usePostApiJsApPayeesInvitationsPermission = <
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePostApiJsApPayeesInvitationsPermissionHook>
      >
    >,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    usePostApiJsApPayeesInvitationsPermissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get Payee Contact Inform Email Template for Office Member
 */
export const useGetApPayeeContactInformTemplateHook = () => {
  const getApPayeeContactInformTemplate =
    useCustomClient<ApPayeeContactInformEmailTemplateResponse>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApPayeeContactInformTemplate(
      {
        url: `/api/js/ap_payee_contact_inform_template`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApPayeeContactInformTemplateQueryKey = () => {
  return [`/api/js/ap_payee_contact_inform_template`] as const;
};

export const useGetApPayeeContactInformTemplateQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApPayeeContactInformTemplateQueryKey();

  const getApPayeeContactInformTemplate =
    useGetApPayeeContactInformTemplateHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
    >
  > = ({ signal }) => getApPayeeContactInformTemplate(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApPayeeContactInformTemplateQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>>
>;
export type GetApPayeeContactInformTemplateQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get Payee Contact Inform Email Template for Office Member
 */
export const useGetApPayeeContactInformTemplate = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApPayeeContactInformTemplateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApPayeeContactInformTemplateSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApPayeeContactInformTemplateQueryKey();

  const getApPayeeContactInformTemplate =
    useGetApPayeeContactInformTemplateHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
    >
  > = ({ signal }) => getApPayeeContactInformTemplate(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApPayeeContactInformTemplateSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>>
>;
export type GetApPayeeContactInformTemplateSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get Payee Contact Inform Email Template for Office Member
 */
export const useGetApPayeeContactInformTemplateSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
  >,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetApPayeeContactInformTemplateHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApPayeeContactInformTemplateSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
